import { CHANGE_INPUT_SEARCH, SUBMIT_FORM } from "../actions/actionTypes.js";

const initialState = {
  title: "Еколого-гідрологічний геопортал",
  navList: [
    { text: "Головна", to: "/" },
    {
      text: "Річки України",
      to: "/rivers",
    },
    {
      text: "Хімічні елементи",
      to: "/chemicals",
    },
  ],
  search: {
    name: "search",
    type: "text",
    placeholder: "Пошук:",
  },
  signButtons: {
    signIn: {
      icon: "sign-in-alt",
      to: "/signIn",
    },
    signOut: {
      icon: "sign-out-alt",
      disabled: true,
    },
  },
};

export default function headerReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_INPUT_SEARCH:
      return { ...state, search: { ...action.input } };
    case SUBMIT_FORM:
      return { ...state };
    default:
      return state;
  }
}
